/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：568
 */

module.exports = {
  noData: "VariableList_noData__3Lxu2",
  emptyText: "VariableList_emptyText__n6TcW",
  list: "VariableList_list__lY1ky",
  watchBox: "VariableList_watchBox__24Q37",
  category: "VariableList_category__2y773",
  categoryIcon: "VariableList_categoryIcon__3wVXV",
  categoryText: "VariableList_categoryText__1ARyd"
}
